import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { useTranslation } from "react-i18next";
import logo1 from "../../svg/logo1.png";
import logo2 from "../../svg/logo2.png";
import changeVersion from "../../svg/nav-school.png";
import changeVersion_de from "../../svg/nav-school-de.png";

import changeVersion1 from "../../svg/nav-white.png";
import changeVersion1_de from "../../svg/nav-white-de.png";

import changeVersion2 from "../../svg/nav-black.png";
import changeVersion2_de from "../../svg/nav-black-de.png";

import changeMobileVersion from "../../svg/mb2.png";
import changeMobileVersion_de from "../../svg/mb2-de.png";

import changeMobileVersion1 from "../../svg/mb3.png";
import changeMobileVersion1_de from "../../svg/mb3-de.png";

import changeMobileVersion2 from "../../svg/mb1.png";
import changeMobileVersion2_de from "../../svg/mb1-de.png";

import { Link } from "react-router-dom";
import Language from "./Language";
import dropdownButton from "../../svg/arrrow-green.png";

const Arrow = ({ color }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="pointer-events-none"
  >
    <path
      d="M6 9l6 6 6-6"
      stroke={color}  
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);



const Menu = (props) => {
  const [t, i18n] = useTranslation("global");
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Function to handle window resize and update the state
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{
    if(windowWidth > 1022){
      setShowMenu(false)
    }
    
  })

  const ClickHandler = () => {
    setShowMenu(!showMenu);
  };

  let backgroundHeader =
  "bg-black/90 border-b-2 border-red-800 fixed top-0 left-0 right-0 z-20 lg:h-32";
  if (props.changeVersionHandler === "academic") {
    backgroundHeader =
      "bg-white border-b-2 border-[#1acfbd] fixed top-0 left-0 right-0 z-20 lg:h-32";
  }
  if (props.changeVersionHandler === "school") {
    backgroundHeader =
      "bg-white border-b-2 border-[#6832c7] fixed top-0 left-0 right-0 z-20 lg:h-32";
  }


  let colorText =
    "sticky top-0  mx-auto  grid grid-cols-5 w-9/12 text-white text-2xl font-bold underline-offset-0 flex justify-center";
  let colors =
    "text-white hover:text-white text-1xl font-bold underline-offset-0";
  let colorsMobile =
    "h-full relative z-10 text-white hover:text-white text-1xl font-bold underline-offset-0 flex justify-start pl-8  sm:pl-24 text-3xl w-96 leading-3 flex items-center";
  let colorMobileBg = "bg-black fixed top-16 left-0 right-0 z-20 h-screen";
  if (props.changeVersionHandler === "academic") {
    colorText =
      "sticky top-0 mx-auto  grid grid-cols-5 w-9/12 text-2xl text-black font-bold underline-offset-0 flex justify-center";
    colors =
      "text-1xl text-black hover:text-black font-bold underline-offset-0";
    colorsMobile =
      "h-full relative z-10 text-1xl text-black hover:text-black font-bold underline-offset-0 flex justify-start pl-8 sm:pl-24 text-3xl w-96 leading-3 flex items-center";
    colorMobileBg = "bg-white fixed top-16 left-0 right-0 z-20 h-screen";
  }
  if (props.changeVersionHandler === "school") {
    colorText =
      "sticky top-0 mx-auto  grid grid-cols-5 w-9/12 text-2xl text-black font-bold underline-offset-0 flex justify-center";
    colors =
      "text-1xl text-black hover:text-black font-bold underline-offset-0";
    colorsMobile =
      "h-full relative z-10 text-1xl text-black hover:text-black font-bold underline-offset-0 flex justify-start pl-8 sm:pl-24 text-3xl w-96 leading-3 flex items-center";
    colorMobileBg = "bg-white fixed top-16 left-0 right-0 z-20 h-screen";
  }
  return (
    <div>
      <div className={backgroundHeader}>
        <nav className={colorText}>
          {props.changeVersionHandler === "users" && !props.ticketsShow && (
            <AnchorLink
              href="#home"
              className="flex justify-start w-32 lg:w-full sm:-ml-28 -ml-12"
            >
              <img className="lg:w-60" src={logo1} alt="logo"/>
            </AnchorLink>
          )}

          {(props.changeVersionHandler === "academic" || props.changeVersionHandler === "school") && !props.ticketsShow && (
            <AnchorLink
              href="#home"
              className="flex justify-start w-32 lg:w-full sm:-ml-28 -ml-12"
            >
              <img className="lg:w-60" src={logo2} alt="logo" />
            </AnchorLink>
          )}
          {!props.changeVersionHandler && !props.ticketsShow && (
            <AnchorLink
              href="#home"
              className="flex justify-start w-32 lg:w-full sm:-ml-28 -ml-12"
            >
              <img href="#about" src={logo2} className="lg:w-60" alt="logo" />
            </AnchorLink>
          )}
          {props.changeVersionHandler === "users" && props.ticketsShow && (
            <Link
              to={"/"}
              className="flex xl:self-start justify-start w-32 lg:w-full xl:-ml-0 -ml-10"
            >
              <img href="#about" src={logo1} className="lg:w-60" alt="logo" />
            </Link>
          )}
          {props.changeVersionHandler === true && props.ticketsShow && (
            <Link
              to={"/"}
              className="flex xl:self-start justify-start w-32 lg:w-full xl:-ml-0 -ml-10"
            >
              <img href="#about" src={logo1} className="lg:w-60" alt="logo" />
            </Link>
          )}
          {(props.changeVersionHandler === "academic" || props.changeVersionHandler === "school")&& props.ticketsShow && (
            <Link
              to={"/"+props.changeVersionHandler}
              className="flex xl:self-start justify-start w-32 lg:w-full xl:-ml-0 -ml-10"
            >
              <img href="#about" src={logo2} className="lg:w-60" alt="logo" />
            </Link>
          )}
          {!props.changeVersionHandler === "school"  && props.ticketsShow && (
            <Link
              to={"/school"}
              className="flex xl:self-start justify-start w-32 lg:w-full xl:-ml-0 -ml-10"
            >
              <img href="#about" src={logo2} className="lg:w-60" alt="logo" />
            </Link>
          )}
          {!props.changeVersionHandler === "academic"  && props.ticketsShow && (
            <Link
              to={"/academic"}
              className="flex xl:self-start justify-start w-32 lg:w-full xl:-ml-0 -ml-10"
            >
              <img href="#about" src={logo2} className="lg:w-60" alt="logo" />
            </Link>
          )}
          {props.ticketsShow && (
            <button
              onClick={() => navigate(-1)}
              className="col-start-5 flex justify-end items-center text-3xl text-green-ticket -mr-10 lg:mr-0"
            >
              <img
                src={dropdownButton}
                className="w-10 rotate-90"
                alt="logo"
              />
              <div
                className="pl-4 font-normal"
                style={{ fontFamily: "sf-pro-medium" }}
              >
                {t("tickets.back")}
              </div>
            </button>
          )}
          {!props.ticketsShow && (
            <div className={`grid -ml-16 sm:-ml-28 xl:grid-cols-7 md:grid-cols-3 sm:grid-cols-3 place-items-center col-start-2 col-span-3 justify-items-end hidden space-x-7 lg:flex self-center break-space ${windowWidth < 1350 ? 'text-base' : ''}`}>
              <AnchorLink
                className={colors}
                style={{ fontFamily: "Poppins" }}
                href="#moreInfo"
              >
                {t("menu.about")}
              </AnchorLink>
              <AnchorLink
                className={colors}
                style={{ fontFamily: "Poppins" }}
                href="#program"
              >
                {t("menu.program")}
              </AnchorLink>
              <Link
                className={colors}
                style={{ fontFamily: "Poppins" }}
                href="#tickets"
                to={"/tickets"}
              >
                {t("menu.get-tickets")}
              </Link>

              <AnchorLink
                className={colors}
                style={{ fontFamily: "Poppins" }}
                href="#schedule"
              >
                {t("menu.schedule")}
              </AnchorLink>
              
              <AnchorLink
                className={colors}
                style={{ fontFamily: "Poppins" }}
                href="#contacts"
              >
                {t("menu.contacts")}
              </AnchorLink>

              {!props.ticketsShow && (
                <>
                  <div className="hidden lg:flex items-center space-x-7 relative">
                    <select
                      value={props.changeVersionHandler}
                      onChange={(e) => navigate("/" + (e.target.value === "users" ? "" : e.target.value))}
                      className={`
                        appearance-none bg-transparent border-2 px-4 py-2 pr-10 rounded-lg cursor-pointer 
                        ${props.changeVersionHandler === "users" ? "text-white border-white" : ""}
                        ${props.changeVersionHandler === "academic" ? "text-black border-[#1acfbd]" : ""}
                        ${props.changeVersionHandler === "school" ? "text-black border-[#6832c7]" : ""}
                      `}
                    >
                      <option value="users" style={{color:'black'}}>{t("version.users")}</option>
                      <option value="school" style={{color:'black'}}>{t("version.school")}</option>
                      <option value="academic" style={{color:'black'}}>{t("version.academic")}</option>
                    </select>
                    <div className="absolute right-3 top-1/2 -translate-y-1/2">
                      {props.changeVersionHandler === "users" && <Arrow color="#FFFFFF" />}
                      {props.changeVersionHandler === "academic" && <Arrow color="#19d1b8" />}
                      {props.changeVersionHandler === "school" && <Arrow color="#6832c7" />}
                    </div>
                  </div>
                  <div className="flex items-center">
                    <Language />
                  </div>
                </>
              )}
            </div>
          )}

          {!props.ticketsShow && props.changeVersionHandler === "users" && (
            <Link to="school" className="col-start-7">
              <img
                className="fixed top-0 right-0 h-32  hidden space-x-8 lg:flex self-center float:right"
                src={ i18n.language === "en" ? changeVersion : changeVersion_de}
                alt="button"
              />
            </Link>
          )}
          {!props.ticketsShow && props.changeVersionHandler === "academic" && (
            <Link to="/" className="col-start-7">
              <img
                className="fixed top-0 right-0 h-32  hidden space-x-8 lg:flex self-center"
                src={i18n.language === "en" ? changeVersion1 : changeVersion1_de}
                alt="button"
              />
            </Link>
          )}
          {!props.ticketsShow && props.changeVersionHandler === "school" && (
            <Link to="/academic" className="col-start-7">
              <img
                className="fixed top-0 right-0 h-32  hidden space-x-8 lg:flex self-center"
                src={i18n.language === "en" ? changeVersion2 : changeVersion2_de}
                alt="button"
              />
            </Link>
          )}

          {!props.ticketsShow && (
            <div className="dropdown flex lg:hidden top-0 col-start-6 row-start-1 py-3">
              <button
                onClick={ClickHandler}
                className="space-y-2 border-2 border-green-white py-3 px-2"
              >
                <span className="block w-8 h-0.5 bg-green-white animate-pulse"></span>
                <span className="block w-8 h-0.5 bg-green-white animate-pulse"></span>
                <span className="block w-8 h-0.5 bg-green-white animate-pulse"></span>
              </button>
            </div>
          )}
        </nav>
      </div>
      {showMenu && (
        // <ul className="dropdown-menu absolute hidden text-gray-700 pt-20 inset-y-0 right-0 grid-col-1 w-full">
        <div className={colorMobileBg}  style={{height:"80%", height: "calc(100vh - 4rem)"}}>
          <div className="flex flex-col items-start justify-center h-full pt-10">
            <AnchorLink
              className={`${colorsMobile} + pt-2`}
              style={{ fontFamily: "Poppins"}}
              href="#moreInfo"
              onClick={ClickHandler}
            >
              {t("menu.about")}
            </AnchorLink>
            <AnchorLink
              className={colorsMobile}
              style={{ fontFamily: "Poppins"}}
              href="#program"
              onClick={ClickHandler}
            >
              {t("menu.program")}
            </AnchorLink>
            <Link
              className={colorsMobile}
              style={{ fontFamily: "Poppins"}}
              href="#tickets"
              to="/tickets"
              onClick={ClickHandler}
            >
              {t("menu.get-tickets")}
            </Link>

            <AnchorLink
              className={colorsMobile}
              style={{ fontFamily: "Poppins"}}
              href="#schedule"
              onClick={ClickHandler}
            >
              {t("menu.schedule")}
            </AnchorLink>

            <AnchorLink
              className={colorsMobile}
              style={{ fontFamily: "Poppins"}}
              href="#contacts"
              onClick={ClickHandler}
            >
              {t("menu.contacts")}
            </AnchorLink>
            
            <div className="relative pl-8 sm:pl-24 z-10" style={{ width: "80%" }}>
              <select
                value={props.changeVersionHandler}
                onChange={(e) =>
                  navigate("/" + (e.target.value === "users" ? "" : e.target.value))
                }
                className={`
                  appearance-none bg-transparent border-2 w-full px-4 py-3 pr-12 rounded-lg cursor-pointer
                  ${props.changeVersionHandler === "users" ? "text-white border-white" : ""}
                  ${props.changeVersionHandler === "academic" ? "text-black border-[#1acfbd]" : ""}
                  ${props.changeVersionHandler === "school" ? "text-black border-[#6832c7]" : ""}
                `}
                style={{ fontFamily: "Poppins" }}
              >
                <option value="users" style={{ color: "black" }}>{t("version.users")}</option>
                <option value="school" style={{ color: "black" }}>{t("version.school")}</option>
                <option value="academic" style={{ color: "black" }}>{t("version.academic")}</option>
              </select>
              {props.changeVersionHandler === "users" && (
                <div className="absolute right-5 top-1/2 -translate-y-1/2">
                  <Arrow color="#FFFFFF" />
                </div>
              )}
              {props.changeVersionHandler === "academic" && (
                <div className="absolute right-5 top-1/2 -translate-y-1/2">
                  <Arrow color="#19d1b8" />
                </div>
              )}
              {props.changeVersionHandler === "school" && (
                <div className="absolute right-5 top-1/2 -translate-y-1/2">
                  <Arrow color="#6832c7" />
                </div>
              )}
            </div>



            
            <div className={colorsMobile}>
              {t("menu.language")}
              <Language onClick={ClickHandler} />
            </div>

            
          </div>
        </div>

        // </ul>
      )}
    </div>
  );
};
// createRoot.render(<Menu />, document.getElementById("content"));

export default Menu;
